/**
 * bm-home-product-feature.js
 * Accordion — toggle trigger aria-expanded + show/hide panel.
 * Supports multiple section instances on the same page.
 */
(function () {
  'use strict';

  function initAccordions(scope) {
    scope.querySelectorAll('.bm-product-feature__accordion-item').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isOpen  = this.getAttribute('aria-expanded') === 'true';
        var panelId = this.getAttribute('aria-controls');
        var panel   = panelId ? document.getElementById(panelId) : null;

        this.setAttribute('aria-expanded', isOpen ? 'false' : 'true');

        if (panel) {
          panel.hidden = isOpen;
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAccordions(document);
  });

  // Shopify theme editor live re-init
  document.addEventListener('shopify:section:load', function (e) {
    initAccordions(e.target);
  });
})();